const root = '/transactions';

export const transactionsEndpoints = { root };
